import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRbSystemAlert } from '@scmlatam/web-ui';
import { serviceSchedule } from '../services/service';
import type { Options } from '../types/hooks';
import { usePermisoSchedule } from '../../../../auth/permisosModulos';

interface UseFormDeletePaycodeProps {
    paycodeAssignId: string | null;
    reload: () => Promise<void> | void;
    option: Options | null;
    setOption: (value: Options | null) => void;
}

const useFormDeletePaycode = ({ paycodeAssignId, reload, option, setOption }: UseFormDeletePaycodeProps) => {
    const { t } = useTranslation('schedule.form.delete_paycode');
    const { showAlert } = useRbSystemAlert();
    const canDeletePaycode = usePermisoSchedule('delete_paycode');
    const [openForm, setOpenForm] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (option === 'delete_paycode_assign' && paycodeAssignId) {
            if (canDeletePaycode) setOpenForm(true);
            setOption(null);
        }
    }, [option, paycodeAssignId, setOption, canDeletePaycode]);

    const closeForm = () => {
        setOpenForm(false);
    };

    const submit = async () => {
        if (!paycodeAssignId || !canDeletePaycode) return;

        setLoading(true);

        try {
            const ok = await serviceSchedule.deletePaycode({
                paycodeAssignId,
                alert: { t, showAlert },
            });

            if (ok) {
                await reload();
                closeForm();
            }
        } finally {
            setLoading(false);
        }
    };

    return {
        t,
        title: t('delete_paycode.title'),
        openForm,
        setOpenForm,
        closeForm,
        loading,
        submit,
    };
};

export { useFormDeletePaycode };
